import { AuthFrame } from '../components/auth-frame';
import { ForgotPasswordCard } from '../components/forgot-password-card';

export function ForgotPasswordPage() {
  return (
    <AuthFrame>
      <ForgotPasswordCard />
    </AuthFrame>
  );
}
